// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__BbJlI","iframeContainer":"styles_iframeContainer__Pl4Nv"};